module.exports = __webpack_public_path__ + "img/state-weho-alt.b1fc96db.jpg";